import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "side-menu-links-container flex-container flex-dir-column" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "side-menu-text" }
const _hoisted_5 = { class: "side-menu-footer-links-container" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "side-menu-text" }, "Settings", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "side-menu-text" }, "Log out ", -1)

import { NLayout, NLayoutSider, NLayoutContent, NIcon } from 'naive-ui'
import { augmentifyLogo, homeIcon, augmentIcon, projectsIcon, meetingsIcon, settingsOutline } from "@/assets/utils/icons";
import FooterComponent from "@/components/FooterComponent.vue";
import { LogOutSharp } from '@vicons/material'
import type { MenuItem } from '@/ts/interfaces/layout/MenuItem';
import { useAuthLogoutStore } from "@/stores/auth/logout.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutView',
  setup(__props) {

const authLogoutStore = useAuthLogoutStore()

const handleLogout = () => {
  authLogoutStore.logout()
}

const sideMenuRoutes: Array<MenuItem> = [
  {
    text: 'Home',
    icon: homeIcon,
    routeName: 'client-home',
    show: true
  },
  {
    text: 'Augment',
    icon: augmentIcon,
    routeName: 'client-home',
    show: false
  },
  {
    text: 'Projects',
    icon: projectsIcon,
    routeName: 'client-projects-index',
    show: true
  },
  {
    text: 'Meetings',
    icon: meetingsIcon,
    routeName: 'meetings',
    show: true
  },
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NLayout), { position: "absolute" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NLayout), {
        "has-sider": "",
        position: "absolute"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NLayoutSider), {
            width: "250",
            class: "side-menu-container",
            "content-class": "side-menu flex-container flex-dir-column"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "side-menu-logo",
                innerHTML: _unref(augmentifyLogo)
              }, null, 8, _hoisted_1),
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sideMenuRoutes, (route, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                    (route.show)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "flex-container side-menu-link",
                          to: { name: route.routeName }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "icon",
                              innerHTML: route.icon
                            }, null, 8, _hoisted_3),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(route.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  class: "flex-container side-menu-link",
                  to: { name: 'settings' }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "icon",
                      innerHTML: _unref(settingsOutline)
                    }, null, 8, _hoisted_6),
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createElementVNode("a", {
                  class: "flex-container flex-center side-menu-link",
                  onClick: _withModifiers(handleLogout, ["prevent"])
                }, [
                  _createVNode(_unref(NIcon), { class: "icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LogOutSharp))
                    ]),
                    _: 1
                  }),
                  _hoisted_8
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NLayout), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NLayoutContent), { "content-class": "client-layout-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              }),
              _createVNode(FooterComponent, { position: "absolute" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})